WiseMetering.Views.NewSiteDocument = WiseMetering.Views.Modal.Save.extend({
    className: 'mbx-info text-left',
    form_prefix: 'site_document',
    template: 'templates/site_documents/new',
    title: () => i18next.t('modal.title.site_documents.new'),

    ui: {
        uploadFile: '#upload-file'
    },

    afterSave: function() {
        WiseMetering.siteDocuments.fetch();
    },

    getFormData: function() {
        const data = this.formSerializer();
        data.file = this.ui.uploadFile.prop('files')[0];

        return data;
    },

    submitData: function(data) {
        data.site_id = this.model.get('site_id');
        let formData = new FormData();
        for (let key in data) {
            formData.append(key, data[key]);
        }

        // https://stopbyte.com/t/how-to-send-multipart-formdata-with-jquery-and-ajax/58/2
        return $.ajax({
            contentType: false,
            data: formData,
            processData: false,
            type: 'POST',
            url: '/site_documents'
        });
    }
});
